import React from "react";
import { NavLink } from "react-router-dom";
import * as S from "./styles";
import { ThisPaths } from "../../shared/Constants";
import { ProfileAndExit } from "./ProfileAvatar";

type MainBarProps = {
    open: boolean;
};

const RightNav: React.FC<MainBarProps> = ({ open }) => {
    return (
        <>
            <S.Ul open={open}>
                <NavLink
                    to={ThisPaths.MENU}
                    activeStyle={{
                        fontWeight: "bold",
                        color: "#0DADEA",
                    }}
                >
                    <li>Comedor</li>
                </NavLink>
                <NavLink
                    to={ThisPaths.HISTORY}
                    activeStyle={{
                        fontWeight: "bold",
                        color: "#0DADEA",
                    }}
                >
                    <li>Mi Historial</li>
                </NavLink>
                <NavLink
                    to={ThisPaths.CHANGE_PASSWORD}
                    activeStyle={{
                        fontWeight: "bold",
                        color: "#0DADEA",
                    }}
                >
                    <li>Seguridad</li>
                </NavLink>
                <ProfileAndExit />
            </S.Ul>
        </>
    );
};

export default RightNav;
